import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-show',
  templateUrl: './alert-show.component.html',
  styleUrls: ['./alert-show.component.css']
})
export class AlertShowComponent implements OnInit {
  massage: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/alert-show/alert-show.component.ts